import * as Actions from '../Actions/PWAActions';
// import _ from '@lodash';

const initialState = {
proposalEvent : null,
};

const PWAReducer = function (state = initialState, action) {
  switch ( action.type )
  {
    case Actions.SET_EVENT:
    {
        return {
            ...state,
            proposalEvent: action.payload,
        };
    }
    default:
    {
        return state;
    }
  }
};

const reducer = PWAReducer;

export default reducer;
  